import Nav from "./nav";
import Footer from "./footer";
import { useRouter } from "next/router";
import { useSession } from "@/components/providers/session";
import { useEffect, useState } from "react";
import FixedBanner from "./fixed-banner";

export default function Layout({ siteData, children, ...rest }) {
  const router = useRouter();
  const session = useSession();
  const [selectedCoursesCount, setSelectedCoursesCount] = useState(
    session.selectedCourses ? session.selectedCourses.length : 0
  );

  useEffect(() => {
    setTimeout(() => {
      setSelectedCoursesCount(
        session.selectedCourses ? session.selectedCourses.length : 0
      );
    }, 1000);
  }, [session.selectedCourses.length]);

  const pts = router.asPath.split("/").filter(Boolean);
  let promo = router.asPath === "/" || pts.length < 2;
  let online =
    router.asPath === "/courses/elearning/" ||
    router.asPath === "/courses/elearning";

  if (router.asPath.includes("/account")) {
    promo = false;
  }

  return (
    <>
      <FixedBanner router={router} />
      <div className="relative bg-white flex min-h-screen flex-col overflow-hidden">
        {siteData ? <Nav {...rest} siteData={siteData} /> : null}
        {/* <p className="mt-24 lg:mt-0 text-white flex bg-brand-600 justify-center pt-2 pb-2 hover:text-gray-200 shadow overflow-hidden">
          <svg
            className="h-6 w-6 block"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
          <a
            href={`tel:+44${siteData.fields.phoneNumber
              .replace(/^0+/, "")
              .replace(/\s/g, "")}`}
            className="flex"
          >
            <span className="text-base block ml-2">Call us now on </span>
            <span className="sr-only">Phone number</span>
            <span className="text-base block ml-1 underline">
              {siteData.fields.phoneNumber}
            </span>
          </a>
        </p> */}
        <main className="flex flex-col flex-1 w-full">{children}</main>
        {siteData ? <Footer siteData={siteData} /> : null}
        <div className="sr-only w-0 h-0 overflow-hidden">
          <a href="/courses/injectables/">Accredited Injectable Training Courses</a>
          <a href="/courses/cpd/">CPD Accredited Training Courses</a>
          <a href="/training-course-calendar/">Training Course Calendar</a>
          <a href="/about/">About Us</a>
          <a href="/team/">Meet The Team</a>
          <a href="/courses/education">Education Training Courses</a>
          <a href="/courses/masterclasses/">Masterclasses Training Courses</a>
          <a href="/courses/new/">New Courses</a>
        </div>
      </div>
    </>
  );
}
